import { Component, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { CryptoService, CustomerServiceProvider, DialogCloseService } from '../../../_services/services';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { FarmModel } from 'src/app/_models/customer/farm-fields-splts.model';
import { FarmAndFieldSplitsComponent } from '../farm-field-splits/farm-field-splits.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomerDetails } from 'src/app/_models/customer/customer-details.model';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { LoadingService } from 'src/app/_services/loading.service';

interface FlatNode {
  expandable: boolean;
  name: string;
  level: number;
  field: any;
};

@Component({
  selector: 'app-farm-field',
  templateUrl: './farm-field.component.html',
  styleUrls: ['./farm-field.component.css'],
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule
  ],
})
export class FarmAndFieldsComponent implements AfterViewInit {

  @Input() customer: CustomerDetails;
  @Input() isDifferentLocationItemSelected: boolean;
  @Output() sendResponseEventEmitter = new EventEmitter<any>();
  isSalesProUser: boolean;
  farmAndFields: FarmModel[];
  dialogOpen: boolean;
  isExpanded: boolean = false;
  private _transformer = (node: any, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      field: node
    };
  };

  treeControl = new FlatTreeControl<FlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  constructor(
    private cryptoService: CryptoService,
    private customerService: CustomerServiceProvider,
    private dialog: MatDialog,
    private closeDialogService: DialogCloseService,
    private blockUI: LoadingService
  ) {
    // this.blockUI.start();
    /****** Get and Set Sales Pro Config ********/
    this.isSalesProUser = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? true : false

  }
  ngAfterViewInit(): void {
    // Fetch tree data from server
    this.dialogOpen = false;
    const promises = [];
    const promises1 = [];
    var ccSplits;
    this.blockUI.start();
    this.customerService.getSplitsByClientId(this.customer.Id).then((clientSplits) => {
      var cSplits = JSON.stringify(clientSplits);
      clientSplits.forEach((c) => {
        c.IsPrimary = c.ClientId == c.SplitClientId;
        c.name = c.SplitClientIdDV + (c.IsPrimary ? ' (primary)' : ' (Included)');
        c.FarmName = c.SplitClientId;
        if (c.IsPrimary) {
          c.FarmSplits = JSON.parse(cSplits);
        }
        c.NameId = c.SplitClientId;
        c.isClient = true;
      });
      this.customerService.getSplitsBySplitClientId(this.customer.Id).then((splits) => {
        ccSplits = JSON.stringify(splits);
        splits.forEach((s) => {
          s.IsPrimary = s.ClientId == s.SplitClientId;
          s.name = s.ClientIdDV + ' (Included)';
          s.NameId = s.ClientId;
          s.FarmName = s.ClientId;
          s.isClient = true;
          if (!(clientSplits.filter(x => x.SplitCode == s.SplitCode).length > 0)) {
            clientSplits.push(s);
          }
        });
        this.farmAndFields = [];

        let uniqueArray = clientSplits.filter((obj, index) => {
          return index === clientSplits.findIndex((o) => {
            return o.name === obj.name;
          });
        });

        uniqueArray.forEach((s) => {
          this.farmAndFields.push(s);
        });

        if (this.farmAndFields.length > 0 && this.farmAndFields.filter(x => x.IsPrimary).length > 0)
          this.blockUI.start();
        else {
          let primaryClient = new FarmModel();
          primaryClient.NameId = this.customer.Id
          primaryClient.name = this.customer.name + ' (primary)';
          primaryClient.IsPrimary = true;
          primaryClient.isClient = true;
          primaryClient.isDisabled = true;
          this.farmAndFields.unshift(primaryClient);
          this.blockUI.start();
        }


        this.farmAndFields.forEach((split: any) => {
          promises1.push(this.customerService.getFarmsByCustomer(split.NameId).then(farms => {
            // Set data source with fetched data
            split.children = farms;
            split.children.forEach((farm) => {
              promises.push(this.customerService.getFieldsWithSplitsByFarm(farm.FarmCode).then((fields) => {
                if (!farm.FarmSplits || farm.FarmSplits.length == 0) {
                  farm.isNoSplits = true;
                }
                else {
                  farm.isNoSplits = false;
                }
                farm.children = fields;
                farm.name = farm.FarmName;
                farm.parentSplits = split.IsPrimary ? JSON.parse(cSplits) : JSON.parse(ccSplits);
                farm.children.forEach((field) => {
                  if (!field.FieldSplits || field.FieldSplits.length == 0) {
                    field.isNoSplits = true;
                  } else {
                    field.isNoSplits = false;
                  }
                  field.name = field.FieldName;
                  field.FarmName = farm.FarmName;
                  field.parentSplits = (farm.FarmSplits && farm.FarmSplits.length > 0) ? farm.FarmSplits : (split.IsPrimary ? JSON.parse(cSplits) : JSON.parse(ccSplits));
                });
              }));
            });
          }));
        });
        const promises2 = []
        Promise.all(promises1).then(() => {
          Promise.all(promises).then(() => {
            this.farmAndFields.forEach((client) => {
              if (client.isClient && (client.FarmSplits === undefined)) {
                promises2.push(this.customerService.getSplitsByClientId(client.NameId).then((res) => {
                  let splits = res && res.filter(x => x.SplitClientId == this.customer.Id).length > 0 ? res : null;
                  client.FarmSplits = splits;
                  client.children.forEach((c: any) => {
                    c.parentSplits = c.isNoSplits ? splits : null;
                    //c.FarmSplits = !c.FarmSplits || c.FarmSplits == 0 ? splits : c.FarmSplits;
                    c.FarmSplits = c.FarmSplits ? (c.FarmSplits.filter(x => x.SplitClientId == this.customer.Id).length > 0 ? c.FarmSplits : null) : null;
                    c.isDisabled = (!c.FarmSplits || c.FarmSplits.length == 0) && (!c.parentSplits || c.parentSplits.length == 0);
                    c.children.forEach((cc) => {
                      cc.FieldSplits = cc.FieldSplits ? (cc.FieldSplits.filter(x => x.SplitClientId == this.customer.Id).length > 0 ? cc.FieldSplits : null) : null;
                      cc.parentSplits = cc.isNoSplits ? (c.FarmSplits ? c.FarmSplits : c.isNoSplits ? splits : null) : null;
                      cc.isDisabled = (!cc.FieldSplits || cc.FieldSplits.length == 0) && (!cc.parentSplits || cc.parentSplits.length == 0);
                      //cc.FieldSplits =!cc.FieldSplits || cc.FieldSplits == 0 ? cc.parentSplits : splits;
                      cc.isNotVisible = !cc.isDisabled ? false : this.areAllChildAndGrandchildNodesDisabled(cc);
                    });
                    c.isNotVisible = !c.isDisabled ? false : this.areAllChildAndGrandchildNodesDisabled(c);
                  });
                  client.isDisabled = splits && splits.length > 0 ? false : !splits || splits.length == 0;
                  client.isNotVisible = !client.isDisabled ? false : this.areAllChildAndGrandchildNodesDisabled(client);
                }).finally(() => {
                }));
              }
            });
            Promise.all(promises2).then(() => {
              this.farmAndFields.forEach((farmAndField) => {
                farmAndField.children = farmAndField.children.sort((a, b) => a.name.localeCompare(b.name));
                farmAndField.children.forEach((child: any) => {
                  child = child.children.sort((a, b) => a.name.localeCompare(b.name));
                })
              });

              const unsortedItemIndex = this.farmAndFields.findIndex(item => item.IsPrimary);
              const unsortedItem = this.farmAndFields[unsortedItemIndex];

              const sortableItems = this.farmAndFields.filter((item, index) => index !== unsortedItemIndex);

              sortableItems.sort((a, b) => a.name.localeCompare(b.name));

              let sortedFarmsAndField = [];
              sortedFarmsAndField.push(unsortedItem);
              sortableItems.forEach(item => {
                sortedFarmsAndField.push(item);
              })
              this.dataSource.data = sortedFarmsAndField;
            }).finally(() => {
              this.blockUI.stop();
            });
          });
        });
      });
    });
  }
  hasChild = (_: number, node: FlatNode) => node.expandable;
  areAllChildAndGrandchildNodesDisabled(node: any): boolean {
    if (!node.children || node.children.length === 0) {
      // If node has no children, return its isDisabled attribute
      return node.isDisabled;
    } else {
      // If node has children, recursively check each child and their descendants
      return node.children.every(child =>
        child.isDisabled && (!child.children || child.children.every(grandchild => grandchild.isDisabled))
      );
    }
  }
  showFieldSplits(data) {
    if (!this.dialogOpen) {
      this.dialogOpen = true;
      let splits = data.FieldSplits ? data.FieldSplits : data.FarmSplits;
      splits = !splits || splits.length == 0 ? data.parentSplits : splits;
      splits = splits.sort((a, b) => a.SplitClientIdDV.localeCompare(b.SplitClientIdDV));
      let name = data.ClientIdDV + '/' + data.FarmName + (data.FieldName ? '/' + data.FieldName : '');
      const dialogRef3 = this.dialog.open(FarmAndFieldSplitsComponent, {
        width: window.innerWidth + 'px',
        maxHeight: window.innerHeight - 100 + 'px',
        data: { splits: splits, name: name, isDifferentLocationItemSelected: this.isDifferentLocationItemSelected }
      });

      dialogRef3.afterClosed().subscribe(result => {
        if (result) {
          this.sendResponseEventEmitter.emit({
            splits: splits,
            name: name,
            farmCode: data.FarmCode,
            farmName: data.FarmName,
            fieldCode: data.FieldCode,
            fieldName: data.FieldName,
            clientId: data.ClientId
          });
        }
        this.dialogOpen = false;
      });
      this.closeDialogService.emitRegisterDialog(dialogRef3);
    }
  }
  showFarmSplits(node) {
    if (!this.dialogOpen) {
      this.dialogOpen = true;

      let splits = node.FarmSplits && node.FarmSplits.filter(x => x.SplitClientId == this.customer.Id).length > 0 ? node.FarmSplits : null;
      splits = !splits || splits.length == 0 ? node.parentSplits : splits;
      splits.sort((a, b) => a.SplitClientIdDV.localeCompare(b.SplitClientIdDV));
      const dialogRef = this.dialog.open(FarmAndFieldSplitsComponent, {
        width: window.innerWidth + 'px',
        maxHeight: window.innerHeight - 100 + 'px',
        data: { splits: splits, name: node.ClientIdDV + '/' + node.FarmName, isDifferentLocationItemSelected: this.isDifferentLocationItemSelected }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.sendResponseEventEmitter.emit({
            splits: splits,
            name: !node.isClient ? node.ClientIdDV + '/' + node.FarmName : node.FarmName,
            farmCode: !node.isClient ? node.FarmCode : null,
            farmName: node.FarmName,
            clientId: node.ClientId
          });
        }
        this.dialogOpen = false;
      });
      this.closeDialogService.emitRegisterDialog(dialogRef);
    }
  }
  checkSelected(node: any): boolean {
    return false;
  }
  toggleExpandCollapse(): void {
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }

}
